import React from 'react';
import { functions } from 'constantes';
import CardElemento from './CardElemento';

const ElementoElaboracionPlanDeMediosSegundaVuelta = ({nombreDelMedio, asignarPlanDeMedio, idTipoMedioDeComunicacion, datosDelMedio}) => {
  return (
    <>
      <CardElemento idTipoMedioDeComunicacion={idTipoMedioDeComunicacion}
      datosDelMedio={ {...datosDelMedio, nombreMedio: nombreDelMedio, idEleccion: 1, tipoCandidatura: "PRESIDENCIA"}} asignarPlanDeMedio={asignarPlanDeMedio} />
    </>
  );
}

export default ElementoElaboracionPlanDeMediosSegundaVuelta;